import type { ServerEvent } from '../shared/types';
import { chat } from './store';

/** Opens the event socket and mirrors every server event into the chat store. */
export function connectSocket(): () => void {
  let socket: WebSocket | null = null;
  let closed = false;
  let attempt = 0;

  const connect = () => {
    const protocol = location.protocol === 'https:' ? 'wss' : 'ws';
    socket = new WebSocket(`${protocol}://${location.host}/ws`);
    socket.onopen = () => {
      attempt = 0;
      chat.setConnected(true);
    };
    socket.onmessage = (message) => {
      try {
        chat.applyEvent(JSON.parse(message.data as string) as ServerEvent);
      } catch {
        // ignore malformed frames
      }
    };
    socket.onclose = () => {
      chat.setConnected(false);
      if (closed) return;
      attempt += 1;
      setTimeout(connect, Math.min(500 * 2 ** attempt, 8000));
    };
  };

  connect();
  return () => {
    closed = true;
    socket?.close();
  };
}
